import './cookie-consent.scss';

class CookieConsent {
    constructor() {
        this.initialize();
    }

    initialize () {
        this.cookieConsentWrap();
        this.cookieConsentObserver();
    }

    cookieConsentWrap () {
        const cookieConsentContainer = document.querySelector('[data-consent="popup"]');

        if (cookieConsentContainer && !cookieConsentContainer.closest('.cookie-consent__wrapper')) {
            const cookieConsentContainerWrapper = document.createElement('div');

            cookieConsentContainerWrapper.classList.add('cookie-consent__wrapper');
            cookieConsentContainer.parentNode.insertBefore(cookieConsentContainerWrapper, cookieConsentContainer);
            cookieConsentContainerWrapper.appendChild(cookieConsentContainer);

            if (!cookieConsentContainer.hasAttribute('tabindex')) {
                cookieConsentContainer.setAttribute('tabindex', '0');
            }

            cookieConsentContainer.focus();

            this.setCookieEvents(cookieConsentContainer);

            return true;
        }

        return false;
    }

    cookieConsentObserver () {
        const observer = new MutationObserver((mutations, obs) => {
            if (this.cookieConsentWrap()) {
                obs.disconnect();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    setCookieEvents(cookieConsentContainer) {
        cookieConsentContainer.addEventListener('keydown', (e) => {
            cookieConsentContainer.querySelectorAll('label').forEach((label) => {
                if (!label.hasAttribute('tabindex')) {
                    label.setAttribute('tabindex', '0');
                }
            });

            let isEnter = e.key === 'Enter' || e.keyCode === 13;

            if (isEnter) {
                const $element = e.target;

                if ($element.tagName.toLowerCase() === 'label') {
                    const checkboxId = $element.getAttribute('for');
                    const checkbox = document.getElementById(checkboxId);

                    if (checkbox && !checkbox.disabled) {
                        this.toggleInputChecked(checkbox, !checkbox.checked);
                    }
                }
            }
        });
    }


    toggleInputChecked ($input, state = true) {
        $input.checked = state;

        const toggleInputCheckedEvent = new CustomEvent('change', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        $input.dispatchEvent(toggleInputCheckedEvent);
    }
}

export { CookieConsent };
